const accountStatus = {
  ACTIVE: 'active',
  DISABLED: 'disabled',
};
export default accountStatus;
